import { render, staticRenderFns } from "./MobileNavbar.vue?vue&type=template&id=a48e11c2&scoped=true&"
import script from "./MobileNavbar.vue?vue&type=script&lang=js&"
export * from "./MobileNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavbar.vue?vue&type=style&index=0&id=a48e11c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48e11c2",
  null
  
)

export default component.exports